<div class="text-center">
  <app-phase-bar [color]="providerPhaseColor()" [label]="phaseStatusInfo().phase" />

  <app-tender-phase-action-buttons
    [phaseStatusInfo]="phaseStatusInfo()"
    [tenderId]="tenderId()"
    [colorClass]="providerPhaseColor()"
  />
</div>
